const ProductBundle = (function () {

    var selectors = {
      selects: 'select',
      addToCartButton: '.bundle-products__add'
    };
  

    function ProductBundle(container) {

      this.container = container;

      this.ajaxCart = document.querySelector('ajax-cart');
  
      if (!this.container) {
        return
      }

      this.bundleId = this.container.dataset.bundleId;
      this.bundleTitle = theme.current.product.title;
  
      this.addToCartButton = document.querySelector(selectors.addToCartButton, this.container);
      console.log(this.addToCartButton);
      this.selects = document.querySelectorAll(selectors.selects, this.container);
      console.log(this.selects);
  
      this._bindEvents();
  
    }
  
    ProductBundle.prototype = {
  
      _updateAccordion: function(e) {
        let selected_option_text = e.target.selectedOptions[0].text;
        let id = e.target.id;
        let row_index = id.split("-").slice(-1)[0];
        let id_selector = `bundle-product-wrap-${row_index}`;
        let container = document.getElementById(id_selector);
        let optionContainer = container.querySelector('.selected_option');
        optionContainer.innerHTML = `- ${selected_option_text}`;
        let tickContainer = container.querySelector('.tick');
        if (tickContainer) {
          tickContainer.classList.remove('hidden');
        }
        let editContainer = container.querySelector('.edit');
        if (editContainer) {
          editContainer.classList.remove('hidden');
        }

        let togglebutton = container.querySelector(".accordion__item-toggler.js-toggle-button");
        togglebutton.classList.add("selected");
        togglebutton.click();
      },

      _bindEvents: function () {
        this.addToCartButton.addEventListener('click', this._addToCart.bind(this));
        for (let i=0; i < this.selects.length; i++) {
          this.selects[i].addEventListener('change', this._updateAccordion.bind(this));
        }
      },

      _addToCart: function () {
  
        var self = this;
  
        self.addToCartButton.classList.add('loading');
  
        var quantity = 1,
            bundleId = this.bundleId,
            bundleTitle = this.bundleTitle;
  
        var masterBundleProductProperties = {
          '_master': true,
          '_bundle_product_handle': theme.current.product.handle,
          '_bundle_product_image': theme.current.product.featured_image,
          '_bundle_product_price': theme.current.product.price,
          '_bundle_product_compare_at_price': theme.current.product.compare_at_price,
          '_bundle_product_title': theme.current.product.title,
          '_bundle_product_link': window.location.href,
          '_display': true,
        };
    
        let formData = {
            items: []
        }
        let variantItemsTitles = [];
        for (let i=0; i < self.selects.length; i++) {
          let elem = self.selects[i];
          var variantId = elem.value;
          if (variantId == '0' || variantId == 0) {
            alert("Please select all bundle options");
            return;
          }
          itemId = elem.options[elem.selectedIndex].dataset.bundleItemId;
          itemTitle = elem.options[elem.selectedIndex].dataset.bundleItemTitle;

          let variantAddJSon = {
                'id': variantId,
                'quantity': quantity,
                'properties': {
                  '_bundle_id': bundleId,
                  '_bundle_title': bundleTitle,
                  '_item_id': itemId,
                  '_loading': bundleId,
                  '_bundle-item-index': i,
                  '_bundle_price': theme.current.product.price
                }
              };
  
          masterBundleProductProperties['_bundle-item-title-' + (i + 1)] = itemTitle;
  
          if (i == self.selects.length - 1) {
            variantAddJSon.properties = {...variantAddJSon.properties, ...masterBundleProductProperties, _variant_selected_titles: variantItemsTitles.join(",")};
          } else {
            variantAddJSon.properties = {...variantAddJSon.properties, _display: false };
          }
          
          formData.items.push(variantAddJSon);
        }


        formData['sections'] = this.ajaxCart.getSectionsToRender().map((section) => section.id);
        formData['sections_url'] = window.location.pathname;
        console.log(formData);


        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then(response => {
          console.log(response);
          if (response.status == 422) {
            alert(response.description);
          }
          self.ajaxCart.updateCart(response);
          let product_id = window.theme.current.product.id;
          let bundleIdNew = product_id + Date.now() * 0.357;
          bundleIdNew = bundleIdNew.toString().replace(".","-");
          self.container.dataset.bundleId = bundleIdNew;
          self.bundleId = bundleIdNew;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
  
      }
  
    };
  
    return ProductBundle;
})();


window.addEventListener('DOMContentLoaded', () => {
    let container = document.querySelector(".bundle-products.js");
    if (container) {
        new ProductBundle(container);
    }
});
